import React from 'react'

export default function ArtDetails() {
  return (
    <div>ArtDetails</div>
  )
}
